import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from 'antd';

import { useParams } from 'react-router-dom';
import { errorCatch, GET, JSXMap, useAuth, useTranslateContext } from 'fennec-ui';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSearchParams } from 'react-router-dom';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function RegisterJacTableByDancerEvent(props) {
	const { auth } = props;
	const { eventid } = useParams();
	const [searchParams, setSearchParams] = useSearchParams();

	const t = useTranslateContext();
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState()

	useEffect(() => {
		setLoading(true);

		GET(auth, `/api/report/register-jac-table-by-dancer-event/${eventid}?showdisplay=${searchParams.get("showdisplay") || false}&showempty=${searchParams.get("showempty") || false}&showbasic=${searchParams.get("showbasic") || false}&showcategory=${searchParams.get("showcategory") || false}`, ({ data }) => {
			setData(data)
			setLoading(false);
		}, (err) => errorCatch(err, () => setLoading(false)));

	}, [auth]);

	const ref = useRef(null)

	return (
		<div>
			<ReactToPrint
				trigger={() => {
					// NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
					// to the root node of the returned component as it will be overwritten.
					return <div style={{ display: "flex", justifyContent: "right", padding: "15px 20px" }} >
						<Button type="ghost" style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: "14px", }}><PrinterOutlined /> Печать</Button>
					</div>
				}}
				content={() => ref.current}
			/>
			{(data?.meropriyatie) && <div className="report" ref={ref}>
				<article style={{ padding: "0 20px 50px 20px" }}>
					<div style={{ margin: "25px 15px", textAlign: "center" }}>
						<h3>
							{data.meropriyatie.nazvanieMeropriyatiya}, г. {data.meropriyatie.mestoProvedeniya.name}, {dayjs(data.meropriyatie.nachaloSorevnovaniya).format("DD.MM.YYYY")}
						</h3>
					</div>
					<table border="1" cellPadding={8} className="report-table" style={{ color: "black", margin: "25px auto", tableLayout: "fixed" }}>
						<thead style={{textAlign: "center"}}>
							<tr style={{ backgroundColor: "#ffffc1", overflowWrap: "anywhere" }}>
								<td style={{ fontWeight: "600", minWidth: "55px" }}>№</td>
								<td style={{ fontWeight: "600", minWidth: "55px" }}>Участник</td>
								{JSXMap(data?.rjtKategorii, (kategoriya, idx) => {
									return (<td key={idx} style={{ fontWeight: "600", minWidth: "55px" }}>{kategoriya?.kategoriya?.tantsevalnayaDistsiplina?.nazvanie} / {kategoriya?.kategoriya?.kategoriyaUchastnikov?.nazvanie}</td>)
								})}
							</tr>
							<tr style={{ backgroundColor: "#cccccc", overflowWrap: "anywhere", fontSize: "14px" }}>
								<td style={{ fontWeight: "600", minWidth: "55px" }}></td>
								<td style={{ fontWeight: "600", minWidth: "55px" }}>М({data?.mCount}) + Ж({data?.wCount}) = {data?.mCount + data?.wCount}</td>
								{JSXMap(data?.rjtKategorii, (kategoriya, idx) => {
									let summ = (data?.mCountPlus?.[idx] + data?.wCountPlus?.[idx])
									if (summ > 0) {
										return (<td key={idx} style={{ fontWeight: "600", minWidth: "55px" }}>
											М({data?.mCountPlus?.[idx]}) + Ж({data?.wCountPlus?.[idx]}) = {summ}
										</td>)
									} else {
										return (<td key={idx} style={{ fontWeight: "600", minWidth: "55px" }}></td>)
									}
								})}
							</tr>
						</thead>
						<tbody style={{ fontSize: "14px" }}>
							{JSXMap(data?.rjtByDancerEvent, (item, idx) => {
								return (<tr key={idx}>
									<td style={{ textAlign: "center" }}>{(idx + 1)}</td>
									<td style={{ textAlign: "left" }}>{item.name}</td>
									{JSXMap(data?.rjtKategorii, (kategoriya, idx) => {
										if (item?.dancerEventMap?.[kategoriya?.kategoriya?.ID]?.length) {
											return (<td style={{ textAlign: "left", fontWeight: "bold" }}>+</td>)
										} else {
											return (<td style={{ textAlign: "left", fontWeight: "bold" }}></td>)
										}
									})}
								</tr>)
							})}
						</tbody>
					</table>
				</article>
			</div>}
		</div >);
}
